import { useState, type FormEvent } from "react"
import { Search } from "lucide-react"
import { createSearchParams, useLocation, useNavigate } from "react-router"
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@components/ui/input-group"

export const HeaderSearch = () => {
  const [query, setQuery] = useState("")
  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const trimmedQuery = query.trim()
    if (!trimmedQuery) return

    const pathname = "/search"
    const search = `?${createSearchParams({ query: trimmedQuery })}`
    // Repeating the current search shouldn't add another history entry
    const isCurrentSearch =
      location.pathname === pathname && location.search === search

    navigate({ pathname, search }, { replace: isCurrentSearch })
    setQuery("")
  }

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className="tw:hidden tw:w-full tw:max-w-xs tw:sm:block"
    >
      <InputGroup>
        <InputGroupInput
          placeholder="Search Members"
          aria-label="Search Members"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        <InputGroupAddon align="inline-end">
          <InputGroupButton type="submit" size="icon-xs" aria-label="Search">
            <Search />
          </InputGroupButton>
        </InputGroupAddon>
      </InputGroup>
    </form>
  )
}
